import $api from '../api/api';
import $https from '../api/index';
import $store from '../store';
// 时间戳
function formatDate(time) {
	var now = new Date(time);
	var year = now.getFullYear();
	var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
	var day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
	var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
	var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
	var second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds();
	let data = {
		year,
		month,
		day,
		hour,
		minute,
		second,
		time: year + '-' + month + '-' + day + ' ' + hour + ':' + minute
	}
	return data;
}
// 获取底部友情链接
function getflist() {
	// return new Promise(function(resolve, reject) {
		console.log($api)
        var api = $api.api.footer.footer;
        $https.post({
            type: 'formData',
            api: api
        },'',
        response=>{
            console.log('fooooootttttt',response)
            $store.commit('footerlist',response.data)
            // resolve(res)
        },
        error=>{
            console.log(error)
        })
	// })
}
// 退出登录
 function signout() {
	var api = this.$api.api.login.logout;
	var sign = localStorage.getItem("sign");
	this.$https.post(
	  {
		type: "formData",
		api: api,
	  },
	  {
		sign: sign,
	  },
	  (response) => {
		console.log("response", response);
	  },
	  (error) => {
		console.log(error);
	  }
	);
	localStorage.clear();
	this.$router.go(0);
	// logout
  }
function getflist() {
	// return new Promise(function(resolve, reject) {
		console.log($api)
        var api = $api.api.footer.footer;
        $https.post({
            type: 'formData',
            api: api
        },'',
        response=>{
            // console.log('fooooootttttt',response)
            $store.commit('footerlist',response.data)
            // resolve(res)
        },
        error=>{
            console.log(error)
        })
	// })
}
export default {
    formatDate(data) {
		return formatDate(data);
	},
    // async getflist() {
	// 	return getflist();
	// },
    // getflist() {
	// 	return getflist();
	// },
	signout(){
		return signout();
	}
}



// WEBPACK FOOTER //
// ./src/util/index.js